import * as t from "three";
import { defineQuery as y } from "bitecs";
import { Parent as s } from "../../core/ecs/components.js";
import "../../core/validation/schemas.js";
import { Transform as e, WorldTransform as r } from "./components.js";
import { syncQuaternionFromEuler as d, copyTransform as x, composeTransformMatrix as l, decomposeTransformMatrix as T, syncEulerFromQuaternion as h } from "./utils.js";
const u = new t.Matrix4(), m = new t.Matrix4(), a = new t.Vector3(), c = new t.Quaternion(), f = new t.Vector3(), w = y([e]), H = {
  group: "simulation",
  last: !0,
  update: (n) => {
    const i = w(n.world);
    for (const o of i)
      d(e, o);
    for (const o of i)
      if (n.hasComponent(o, r) || (n.addComponent(o, r), r.rotX[o] = 0, r.rotY[o] = 0, r.rotZ[o] = 0, r.rotW[o] = 1, r.scaleX[o] = 1, r.scaleY[o] = 1, r.scaleZ[o] = 1), !n.hasComponent(o, s))
        x(e, r, o);
      else {
        const p = s.entity[o];
        if (!n.hasComponent(p, r)) continue;
        l(
          r,
          p,
          m,
          a,
          c,
          f
        ), l(
          e,
          o,
          u,
          a,
          c,
          f
        ), m.multiply(u), T(
          m,
          r,
          o,
          a,
          c,
          f
        );
      }
    for (const o of i)
      n.hasComponent(o, s) && n.hasComponent(o, r) && h(r, o);
  }
};
export {
  H as TransformHierarchySystem
};
//# sourceMappingURL=systems.js.map
